import { render, staticRenderFns } from "./approvalTodoRouter.vue?vue&type=template&id=7855d9b8"
import script from "./approvalTodoRouter.vue?vue&type=script&lang=js"
export * from "./approvalTodoRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7855d9b8')) {
      api.createRecord('7855d9b8', component.options)
    } else {
      api.reload('7855d9b8', component.options)
    }
    module.hot.accept("./approvalTodoRouter.vue?vue&type=template&id=7855d9b8", function () {
      api.rerender('7855d9b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/router/approvalTodoRouter.vue"
export default component.exports